import {useQuery} from '@tanstack/react-query';
import {WorkspaceQueryKeys} from './requests/workspace-query-keys';
import {Workspace} from './types/workspace';
import {BackendResponse} from '../http/backend-response/backend-response';
import {apiClient} from '../http/query-client';
import {useAuth} from '../auth/use-auth';

export interface FetchUserWorkspacesResponse extends BackendResponse {
  workspaces: Workspace[];
}

export const PersonalWorkspace: Workspace = {
  name: 'Default',
  default: true,
  id: 0,
  members_count: 1,
};

function fetchUserWorkspaces(): Promise<FetchUserWorkspacesResponse> {
  return apiClient.get(`me/workspaces`).then(response => response.data);
}

function addPersonalWorkspaceToResponse(response: FetchUserWorkspacesResponse) {
  return [PersonalWorkspace, ...response.workspaces];
}

export function useUserWorkspaces() {
  const {hasRoleName} = useAuth();
  const isKunden = hasRoleName('Kunden');

  return useQuery({
    queryKey: WorkspaceQueryKeys.fetchUserWorkspaces,
    queryFn: fetchUserWorkspaces,
    placeholderData: {workspaces: []},
    // Kunden only see shared workspaces — no personal workspace
    select: isKunden
      ? (response: FetchUserWorkspacesResponse) => response.workspaces
      : addPersonalWorkspaceToResponse,
  });
}
